import View                   from '@widesk-ui/components/View';
import useDesignTokens        from '@/hooks/useDesignTokens';
import { Theme }              from '@/TokamapEditor/stores/themeStore';
import PreviewLetter          from '@/TokamapEditor/ux/PreviewLetter';
import { previewBorderWidth } from '@/TokamapEditor/ux/shapeStylePreview';

/**
 * Aperçu miniature d'un thème : pastille ronde reprenant le fond et la bordure de son état normal,
 * avec l'initiale de son nom dans sa couleur de texte — de quoi reconnaître un thème dans une liste
 * déroulante sans l'appliquer.
 *
 * Seul l'état normal est représenté (pas le survol) : c'est ce que voit le visiteur au repos.
 */
export default function ThemeSwatch({ theme, size = 18 }: { theme: Theme; size?: number; }) {
	const tokens = useDesignTokens();

	const style = theme.appearance.normal;
	const initial = theme.name.trim().charAt(0).toUpperCase() || '?';

	return (
		<View
			w={size}
			h={size}
			br="50%"
			center
			style={{
				// Sans `box-sizing`, `w`/`h` désignent la boîte de CONTENU : la bordure s'ajouterait autour
				// et la pastille changerait de taille d'un thème à l'autre (jusqu'à 58px pour une bordure
				// de 20), désalignant les lignes entre elles.
				boxSizing: 'border-box',
				background: style.bgColor,
				// Repli sur la bordure neutre de l'interface quand le thème n'en définit pas : une pastille
				// sans fond NI bordure serait invisible, et donnerait l'impression d'un aperçu cassé.
				border: [
					`${previewBorderWidth(style.borderWidth, size)}px`,
					style.borderDashed ? 'dashed' : 'solid',
					style.borderColor || tokens.border.default,
				].join(' '),
				flexShrink: 0,
			}}
		>
			<PreviewLetter letter={initial} text={theme.text.normal} size={size} />
		</View>
	);
}
